// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SecureUpsearchModelPatientPatientUpsearchModel {
    static getAttributeTypeMap() {
        return SecureUpsearchModelPatientPatientUpsearchModel.attributeTypeMap;
    }
}
SecureUpsearchModelPatientPatientUpsearchModel.discriminator = undefined;
SecureUpsearchModelPatientPatientUpsearchModel.additionalProperties = false;
SecureUpsearchModelPatientPatientUpsearchModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "PatientUpsearchModel"
    },
];
//# sourceMappingURL=secureUpsearchModelPatientPatientUpsearchModel.js.map